import React, { useEffect, useState } from 'react';
import Header from '../../../Components/Dashboard/Header/Header';
import Sidebar from '../../../Components/Dashboard/Sidebar/Sidebar';
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken } from '../../../Utils/utils';
import axios from 'axios';
import * as XLSX from "xlsx";
import "../../HRScreens/AttendanceSheet/AttendanceSheet.css";
import { toast } from 'react-toastify';
import Loader from '../../../Components/loader/loader';
const EmployeeAttendanceSheet = () => {
  const [loading,setLoading] = useState(false);
  const [getAttendance, setGetAttendance] = useState();
  const [showSidebar, setShowSidebar] = useState(true);
  const LoginToken = GetToken();
  const [items, setItems] = useState([]);
  const [file, setFile] = useState(null);
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  const validateFields = () => {
    if (!file) {
      toast.error("Please Upload File");
      return false
    }
    return true;
  }
  const handleimportattendance = () => {
    if (!validateFields()) return;
    setLoading(true);
    let formData = new FormData();
    formData.append('formFile', file);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",          
        "content-type": "multipart/form-data",        
        "authorization": `Bearer ${LoginToken}`,
      },
      data: formData,
      url: `${Apiurl()}/Attendence/ImportAttendence`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          toast.success("Excel file imported successfully");
          setFile("");
          window?.location?.reload();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: 'binary' });
            const xlsxData = XLSX.write(workbook, { bookType: 'xlsx', bookSST: true, type: 'array' });
            const blob = new Blob([xlsxData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'converted_file.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            
        };
        reader.readAsBinaryString(file);
    }
};
const [hideshowinputs, sethideshowinputs] = useState(false);
const convertAttendance=()=>{
  sethideshowinputs(false)
}
const UploadAttendanceSheet=()=>{
  sethideshowinputs(!hideshowinputs)
}
useEffect(() => {
  if (window.innerWidth < 600) {
    const timeoutId = setTimeout(() => {
      setShowSidebar(false);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }
  setShowSidebar(true);
}, [])
  return (
    <>
        {
        loading ? <Loader /> : null
      }
      <div>
        <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <div className="d-flex">
          <Sidebar showSidebar={showSidebar} />
          <div
            className={
              showSidebar
                ? "EMP-main-container-of-all-employees-sheet"
                : "EMP-main-container-of-all-employees-page-new-sheet"
            }
          >
            <div className="EMP-inner-container-of-all-employees-page ">
              <div className="header-of-employees-page row">
                <div className="EMP-all-employee-sheet col">
                  <h4>Excel Attendance Sheet</h4>
                </div>
                <div className="EMP-all-employees-sheet col">
                  <div className="EMP-home-icon-sheet">
                    <BiHomeAlt className="EMP-home-icon-header-sheet" />
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-employee-text-sheet">
                    <p>Attendance</p>
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-all-employee-text-sheet">
                    <p>Attendance Sheet</p>
                  </div>
                </div>
              </div>
         
              <div className='excel-sheet-uploarder' >
              <div>
              {/* <input type="file" onChange={handleFileUpload} /> */}
              </div>
              <div className='excel-sheet-uploarder-inner-container'>
              <div className='Excel-Sheet-uploder'>
        {hideshowinputs ? (
          <div className='all-data' >
          <div className='attendanceuploder-uploder-inputone'>
            <input type="file" onChange={handleFileChange} />
          </div>
            <button className='attendanceuploder-button' onClick={handleimportattendance}>Submit</button>
          </div>
        ) : (
          <div className='attendanceuploder-uploder-input'>
          <input type="file" onChange={handleFileUpload} />
          </div>
          )}
      </div>
      {hideshowinputs?(
        <button className='UploadAttendance' onClick={convertAttendance }>Convert Attendance Sheet</button>
        ):(
          
          <button className='UploadAttendance' onClick={UploadAttendanceSheet}>Upload Attendance Sheet</button>
      )
      }
                </div>
                <table className="table container">
                  <thead>
                    <tr>
                      {/* <th scope="col">InputA</th>
            <th scope="col">InputB</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((d) => (
                      <tr key={d.InputA}>
                        <th>{d.InputA}</th>
                        <td>{d.InputB}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default EmployeeAttendanceSheet